export const onClientEntry = () =>
    typeof window !== 'undefined' &&
    (!!window.MSCompatibleInfo || !!window.operamini) &&
    window.location.replace('/unsupported-browser.html');
